import React from 'react'
import PhoneInput from 'react-phone-input-2'
import './PhoneInput.css'

const CustomPhoneInput = (props) => {
    return <PhoneInput
        {...props}
    />
}


export default CustomPhoneInput
